<template>
  <div class="resume">
    <div class="wrapper">
      <h1>Резюме</h1>

      <div class="resume__content">

        <div class="resume__name">Frontend-разработчик / HTML-верстальщик</div>

        <div class="resume__inform">
          <p><b>Тип занятости:</b> частичная занятость, проектная работа, полная занятость</p>
          <p><b>График работы:</b> гибкий график, полный день (работа в офисе), удаленная работа</p>
        </div>

        <div class="resume__title">Опыт работы</div>

        <div class="resume__list" v-if="listExperience && listExperience.length">
          <div class="resume__item" v-for="(itemExperience, indexExperience) in listExperience" :key="indexExperience">
            <div class="resume__date">{{itemExperience.dateStart}} &mdash; <span class="resume__date_last">{{itemExperience.dateFinish}}</span></div>
            <div class="resume__description">
              <div class="resume__company" v-if="itemExperience.company || itemExperience.companyDescription">
                <div class="resume__company-name">{{itemExperience.company}}</div>
                <div class="resume__company-inform">{{itemExperience.companyDescription}}</div>
              </div>
              <div class="resume__position" v-if="itemExperience.position || itemExperience.positionDescription">
                <div class="resume__position-name">{{itemExperience.position}}</div>
                <div class="resume__position-inform">{{itemExperience.positionDescription}}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="resume__title">Высшее образование</div>

        <div class="resume__list" v-if="listEducation && listEducation.length">
          <div class="resume__item" v-for="(itemEducation, indexEducation) in listEducation" :key="indexEducation">
            <div class="resume__date">{{itemEducation.dateStart}} &mdash; {{itemEducation.dateFinish}}</div>
            <div class="resume__description">
              <div class="resume__company" v-if="itemEducation.company || itemEducation.companyDescription">
                <div class="resume__company-name">{{itemEducation.company}}</div>
                <div class="resume__company-inform">{{itemEducation.companyDescription}}</div>
              </div>
              <div class="resume__position" v-if="itemEducation.position || itemEducation.positionDescription">
                <div class="resume__position-name">{{itemEducation.position}}</div>
                <div class="resume__position-inform">{{itemEducation.positionDescription}}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="resume__title">Ключевые навыки</div>

        <ul class="resume__skills">
          <li class="resume__skills-item">HTML5, CSS3 (блочная кроссбраузерная адаптивная верстка)</li>
          <li class="resume__skills-item">JavaScript (нативный + jQuery), Vue.js</li>
          <li class="resume__skills-item">Препроцессоры CSS: sass/scss</li>
          <li class="resume__skills-item">Верстка макетов *.psd, figma/xd.adobe</li>
          <li class="resume__skills-item">Bitrix: интеграция верстки</li>
          <li class="resume__skills-item">Git</li>
        </ul>

        <div class="resume__title">Дополнительная информация</div>

        <div class="resume__inform">
          <p><b>Гражданство:</b> РФ</p>
          <p><b>Место жительства:</b> Москва, м. Бабушкинская</p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Resume",
  data () {
    return {
      listExperience: [],
      listEducation: []
    }
  },
  methods: {
    listExperienceCreate () {
      this.listExperience = [
        {
          dateStart: 'июнь 2021',
          dateFinish: 'июль 2022',
          company: 'iG-Store (самозанятый)',
          companyDescription: 'Интернет-магазин',
          position: 'html-верстальщик',
          positionDescription: 'Верстка, написание скриптов, верстка и рассылка e-mail'
        },
        {
          dateStart: 'ноябрь 2021',
          dateFinish: 'июнь 2022',
          company: 'М.Видео-Эльдорадо (через партнера)',
          companyDescription: 'Интернет-магазин',
          position: 'html-верстальщик',
          positionDescription: 'Верстка промостраниц, интеграция на сайт'
        },
        {
          dateStart: 'октябрь 2020',
          dateFinish: 'февраль 2021',
          company: 'ООО "ОРС"',
          companyDescription: 'ИТ услуги для авиакомпаний и трэвел-агентств',
          position: 'html-верстальщик',
          positionDescription: 'Верстка, написание скриптов (js, vue.js)'
        },
        {
          dateStart: 'октябрь 2016',
          dateFinish: 'февраль 2020',
          company: 'Кораблик',
          companyDescription: 'Торговля товарами для детей',
          position: 'Верстальщик',
          positionDescription: 'Верстка макетов (psd и figma), скрипты на jQuery, Vue.js, верстка e-mail'
        },
        {
          dateStart: 'август 2015',
          dateFinish: 'октябрь 2016',
          company: 'Фриланс',
          companyDescription: '',
          position: '',
          positionDescription: 'Верстка макетов psd, написание скриптов на jQuery, верстка e-mail'
        },
        {
          dateStart: 'июнь 2014',
          dateFinish: 'август 2015',
          company: 'ООО "Фабрикант.ру"',
          companyDescription: 'Информационные технологии, системная интеграция, интернет',
          position: 'web-верстальщик',
          positionDescription: 'html-верстка, интеграция верстки, написание скриптов на jQuery'
        },
        {
          dateStart: 'октябрь 2012',
          dateFinish: 'декабрь 2013',
          company: 'ИНКОМ-НЕДВИЖИМОСТЬ',
          companyDescription: 'Агентские услуги в недвижимости',
          position: 'HTML-верстальщик',
          positionDescription: 'Верстка psd-макетов'
        },
        {
          dateStart: 'май 2011',
          dateFinish: 'сентябрь 2012',
          company: 'ООО Пауэр интернэшнл - шины',
          companyDescription: 'Шины (розничная торговля)',
          position: 'HTML-верстальщик',
          positionDescription: 'Верстка psd-макетов, размещение материалов на сайт, написание скриптов на jQuery'
        },
        {
          dateStart: 'ноябрь 2010',
          dateFinish: 'январь 2011',
          company: 'ЗАО "Даниес"',
          companyDescription: 'Интернет-магазины: торговля лабороторным оборудованием',
          position: 'Менеджер по интернет-проектам',
          positionDescription: 'Поддержка сайтов компании'
        },
        {
          dateStart: 'июнь 2010',
          dateFinish: 'октябрь 2010',
          company: 'ЗАО "Лига Ветра"',
          companyDescription: 'Интернет-магазины: торговля кондиционерами, вентиляционными системами',
          position: 'Администратор сайтов',
          positionDescription: 'Поддержка сайтов, создание и ведение кампании в Яндекс.Директ, участие в создании новых сайтов (написание ТЗ, контроль и приёмка от компании-разработчика)'
        },
        {
          dateStart: 'апрель 2009',
          dateFinish: 'август 2009',
          company: 'ООО "Автостэлс"',
          companyDescription: 'Интернет-магазин: торговля автозапчастями',
          position: 'Администратор сайта, руководитель web-проекта',
          positionDescription: 'Размещение контента на сайтах, создание и ведение компании в Яндекс.Директ, участие в разработке ТЗ для нового сайта'
        },
        {
          dateStart: 'январь 2007',
          dateFinish: 'март 2009',
          company: 'компания Великан',
          companyDescription: 'Торговля грузовой и спец. техникой',
          position: 'Менеджер по интернет проектам',
          positionDescription: 'Администрирование сайтов компании, создание сайтов (верстка и программирование), оптимизация и редизайн старых сайтов'
        }
      ]
    },
    listEducationCreate () {
      this.listEducation = [
        {
          dateStart: '2000',
          dateFinish: '2005',
          company: 'Тихоокеанский Государственный Экономический Университет',
          companyDescription: 'г. Владивосток',
          position: 'Информатик-экономист',
          positionDescription: 'Прикладная информатика в экономике, очная форма обучения'
        }
      ]
    }
  },
  mounted () {
    this.listExperienceCreate()
    this.listEducationCreate()
  }
}
</script>

<style lang="scss">
.resume {
  position: relative;

  &__content {
    margin-top: 15px;

    @media screen and (min-width: 680px){
      margin-top: 20px;
    }

    @media screen and (min-width: 1024px){
      margin-top: 25px;
    }
  }

  &__name {
    @include font(18px, 22px, $bg-color);

    @media screen and (min-width: 680px){
      @include font(20px, 25px, $bg-color);
    }

    @media screen and (min-width: 1024px){
      @include font(24px, 30px, $bg-color);
    }
  }

  &__title {
    margin: 25px 0 0;
    font-family: Roboto-Bold, sans-serif;
    @include font(16px, 19px, $color-gray);

    @media screen and (min-width: 680px){
      @include font(18px, 22px, $color-gray);
    }

    @media screen and (min-width: 1024px){
      margin: 30px 0 0;
    }
  }

  &__inform {
    margin-top: 15px;

    @media screen and (min-width: 1024px){
      margin-top: 20px;
    }
  }

  &__experience {
    margin-top: 25px;
  }

  &__list {
    position: relative;
    margin: 15px 0 0;
    display: grid;
    grid-template-columns: 1fr;
    grid-row-gap: 15px;

    @media screen and (min-width: 680px){
      margin: 20px 0 0;
      grid-row-gap: 25px;
    }
  }

  &__item {
    display: grid;
    grid-template-columns: 1fr;
    padding: 0 0 0 20px;

    @media screen and (min-width: 1024px){
      grid-template-columns: 150px 1fr;
      padding: 0;
    }
  }

  &__date {
    line-height: 22px;
    margin-left: -20px;

    @media screen and (min-width: 1024px){
      margin: 0;
    }

    &_last {
      white-space: nowrap;
    }
  }

  &__company {
    position: relative;
    margin: 5px 0 0;

    @media screen and (min-width: 1024px){
      margin: 0;
    }

    &-name {
      font-family: Roboto-Bold, sans-serif;
      @include font(14px, 18px, $color-dark-gray);

      @media screen and (min-width: 1024px){
        @include font(16px, 20px, $color-dark-gray);
      }
    }

    &-description {
      margin: 5px 0 0;
    }
  }

  &__position {
    position: relative;
    margin: 10px 0 0;

    &-name {
      font-family: Roboto-Bold, sans-serif;
      @include font(14px, 18px, $color-dark-gray);
    }

    &-description {
      margin: 5px 0 0;
    }
  }

  &__skills {
    display: block;
    margin: 15px 0 0;
    padding: 0;

    @media screen and (min-width: 680px){
      margin: 20px 0 0;
    }

    &-item {
      display: block;

      & + & {
        margin: 3px 0 0;
      }
    }
  }
}
</style>